import React from 'react';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
interface TeamMember {
  name: string;
  title: string;
  bio: string;
  imageUrl: string;
}
export const TeamPage = ({
  darkMode,
  toggleDarkMode
}: {
  darkMode: boolean;
  toggleDarkMode: () => void;
}) => {
  const teamMembers: TeamMember[] = [{
    name: 'Steward Johnson',
    title: 'Chief Executive Officer',
    bio: '3x health tech founder, SaaS builder and investor',
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80'
  }, {
    name: 'Ron Smith',
    title: 'Chairman',
    bio: 'Successful investor, founder coach, former mayor of Bellevue, WA',
    imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80'
  }, {
    name: 'Emily Evans',
    title: 'Chief Strategy Officer',
    bio: 'National health policy and compliance expert, MD at Hedgeye',
    imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80'
  }, {
    name: 'To Be Announced',
    title: 'Chief Technology Officer',
    bio: 'Seasoned healthcare compliance and technology executive',
    imageUrl: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80'
  }];
  return <div className={`min-h-screen w-full ${darkMode ? 'dark bg-gray-900 text-white' : 'bg-white text-gray-900'}`} data-id="element-224">
      <header className="w-full py-4 px-6 md:px-12 flex items-center justify-between border-b border-gray-200 dark:border-gray-800" data-id="element-225">
        <div className="flex items-center" data-id="element-226">
          <Link to="/" className="flex items-center" data-id="element-227">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pLF1xF3x24A3EHrkGHQH5h/RH_Logo%2C_No_Text.png" alt="RootHealth Logo" className="h-8 mr-2" data-id="element-228" />
            <span className="text-xl font-bold text-charcoal-700 dark:text-gray-100" data-id="element-229">
              RootHealth
            </span>
          </Link>
        </div>
        <div className="hidden md:flex items-center space-x-8" data-id="element-230">
          <a href="/#how-it-works" className="text-sm font-medium hover:text-green-600 dark:hover:text-green-400 transition-colors" data-id="element-231">
            How It Works
          </a>
          <a href="/#features" className="text-sm font-medium hover:text-green-600 dark:hover:text-green-400 transition-colors" data-id="element-232">
            Features
          </a>
          <a href="/#pricing" className="text-sm font-medium hover:text-green-600 dark:hover:text-green-400 transition-colors" data-id="element-233">
            Pricing
          </a>
          <Link to="/team" className="text-sm font-medium text-green-600 dark:text-green-400 transition-colors" data-id="element-234">
            Team
          </Link>
          <a href="/#contact" className="text-sm font-medium hover:text-green-600 dark:hover:text-green-400 transition-colors" data-id="element-235">
            Contact
          </a>
        </div>
        <div className="flex items-center space-x-4" data-id="element-236">
          <button onClick={toggleDarkMode} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-237">
            {darkMode ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-238">
                <circle cx="12" cy="12" r="5" data-id="element-239" />
                <path d="M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" data-id="element-240" />
              </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-241">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" data-id="element-242" />
              </svg>}
          </button>
          <button className="md:hidden" aria-label="Menu" data-id="element-243">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-244">
              <line x1="4" x2="20" y1="12" y2="12" data-id="element-245" />
              <line x1="4" x2="20" y1="6" y2="6" data-id="element-246" />
              <line x1="4" x2="20" y1="18" y2="18" data-id="element-247" />
            </svg>
          </button>
        </div>
      </header>
      <main className="w-full" data-id="element-248">
        <section className="w-full py-16 md:py-24 px-6 md:px-12 bg-white dark:bg-gray-900" data-id="element-249">
          <div className="max-w-6xl mx-auto" data-id="element-250">
            <div className="text-center mb-12" data-id="element-251">
              <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-252">
                Proven Leaders in{' '}
                <span className="text-green-500 dark:text-green-400" data-id="element-253">
                  Healthcare
                </span>
                , Compliance, and SaaS
              </h2>
              <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-254">
                Our team brings decades of expertise in healthcare technology,
                compliance, and building successful companies.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-255">
              {teamMembers.map((member, index) => <div key={index} className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden border border-gray-200 dark:border-gray-700 transition-transform hover:translate-y-[-4px]" data-id="element-256">
                  <div className="p-6 flex flex-col items-center text-center" data-id="element-257">
                    <div className="w-32 h-32 mb-6 overflow-hidden rounded-full border-4 border-green-500 dark:border-green-400" data-id="element-258">
                      {index === 0 ? <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/43PsW96EU5d2UXaXmq1tyX/1674066746972.jpg" alt="Steward Johnson" className="w-full h-full object-cover" data-id="element-259" /> : index === 1 ? <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mBb2oNL6s33cjDJSZ7g6sT/IMG_8254_copy.jpg" alt="Team member" className="w-full h-full object-cover" data-id="element-260" /> : index === 2 ? <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hdfvRgHB3pkjMP5JUh7FRp/1565479209897.jpg" alt="Emily Evans" className="w-full h-full object-cover" data-id="element-261" /> : <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full text-gray-300 dark:text-gray-600" data-id="element-262">
                          <circle cx="100" cy="80" r="40" fill="currentColor" data-id="element-263" />
                          <circle cx="100" cy="200" r="80" fill="currentColor" data-id="element-264" />
                        </svg>}
                    </div>
                    <h3 className="text-xl font-bold mb-1" data-id="element-265">{member.name}</h3>
                    <p className="text-sm text-green-500 dark:text-green-400 font-medium mb-3" data-id="element-266">
                      {member.title}
                    </p>
                    <p className="text-gray-600 dark:text-gray-300" data-id="element-267">
                      {member.bio}
                    </p>
                  </div>
                </div>)}
            </div>
            <div className="text-center mt-16" data-id="element-268">
              <a href="/#contact" className="px-8 py-4 bg-green-600 hover:bg-green-700 text-white rounded-md text-lg font-medium transition-colors" data-id="element-269">
                Contact Us
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-270" />
    </div>;
};